export async function run({ elements: { background, title, button, mum }, sound, pixiContext, }) {
    background.sprite.visible = true;
    title.sprite.visible = true;
    mum.sprite.visible = true;
    background.sprite.play();
    title.sprite.play();
    sound.playLoop("background");
    button.sprite.alpha = 0;
    button.sprite.visible = true;
    await pixiContext.fadeIn({
        durationMS: 1000,
        sprite: button.sprite,
    });
    sound.playLoop("pleaseClick");
}
//# sourceMappingURL=loadingAnimation.js.map